// extracted by mini-css-extract-plugin
export var banner = "bP_f7";
export var bannerDescription = "bP_gk";
export var bannerHeader = "bP_gd";
export var bannerIcon = "bP_gf";
export var bannerLabel = "bP_gh";
export var bannerText = "bP_gg";
export var bannerTitle = "bP_gj";
export var breakdown = "bP_gw";
export var breakdownContent = "bP_gz";
export var breakdownList = "bP_gD";
export var breakdownSection = "bP_gB";
export var breakdownSectionTitle = "bP_gC";
export var breakdownTerm = "bP_gF";
export var breakdownToggle = "bP_gx";
export var breakdownToggleLabel = "bP_gy";
export var breakdownValue = "bP_gG";
export var considerCarefully = "bP_f9";
export var deltaNegative = "bP_gv";
export var deltaPositive = "bP_gt";
export var highlyRecommended = "bP_f8";
export var metric = "bP_gp";
export var metricDelta = "bP_gs";
export var metricLabel = "bP_gq";
export var metricValue = "bP_gr";
export var metrics = "bP_gl";
export var metricsGrid = "bP_gn";
export var metricsTitle = "bP_gm";
export var notRecommended = "bP_gc";
export var weighOptions = "bP_gb";
export var wrapper = "bP_bF";